import React from 'react';

import { Alert, Box, Button, ButtonGroup, Heading, Modal, Text, TextButton } from '@zillow/constellation-10';

const header = (
  <Heading level={5} css={{ textAlign: 'center' }}>
    Confirm removing contact
  </Heading>
);

import { useDeleteAccountContact } from '../../hooks/billingPortal';
import type { AdproductsBillingPortalAccountContactDto } from '@zg-rentals/ts-adproducts-client';

const DEFAULT_ERROR = 'Failed to remove contact, please try again later';

export interface RemoveZuoraContactConfirmationModalProps {
  contactToRemove: AdproductsBillingPortalAccountContactDto;
  accountNumber: string;
  handleClose: (refresh: boolean) => void;
}

const RemoveZuoraContactConfirmationModal = ({
  contactToRemove,
  handleClose,
  accountNumber,
}: RemoveZuoraContactConfirmationModalProps) => {
  const { mutateAsync, isPending } = useDeleteAccountContact(accountNumber, contactToRemove);
  const [errorMessage, setErrorMessage] = React.useState('');

  const removeContact = () => {
    mutateAsync()
      .then(() => handleClose(true))
      .catch((e) => {
        if (e.error && e.error.message) {
          setErrorMessage(e.error.message);
        } else {
          setErrorMessage(DEFAULT_ERROR);
        }
      });
  };

  const footer = () => (
    <ButtonGroup aria-label="Modal actions">
      <TextButton onClick={() => handleClose(false)}>Cancel</TextButton>
      <Button loading={isPending} tone="brand" emphasis="filled" onClick={removeContact}>
        Remove
      </Button>
    </ButtonGroup>
  );

  return (
    <Modal
      open={true}
      onOpenChange={() => handleClose(false)}
      size="sm"
      header={header}
      body={
        <>
          <Text>
            Are you sure you would like to remove <strong>{contactToRemove.workEmail}</strong> from receiving invoice
            notifications?
          </Text>
          {errorMessage && (
            <Box css={{ paddingTop: 'md' }}>
              <Alert tone="critical">{errorMessage}</Alert>
            </Box>
          )}
        </>
      }
      footer={footer()}
      closeButton={<span hidden />}
    />
  );
};

export default RemoveZuoraContactConfirmationModal;
